import { render, staticRenderFns } from "./NotScannedOrders.vue?vue&type=template&id=1041d842"
import script from "./NotScannedOrders.vue?vue&type=script&lang=js"
export * from "./NotScannedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports